import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';

class FlightReportOcurrencesTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      flight_report_id: this.props.flight_report_id,
      flight_report_occurrences: this.props.flight_report_occurrences,
      abnormal_occurrence_types_select: this.props.abnormal_occurrence_types_select,
      flight_report_legs_select: this.props.flight_report_legs_select,
      flight_report: this.props.flight_report,
      flight_report_leg_id: null,
      abnormal_occurrence_type_id: null,
      observations: null,
    };

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.fuel_type === 'undefined' || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        flight_report_id: newProps.flight_report_id,
        fuel_type: newProps.fuel_type,
        flight_report_occurrences: newProps.flight_report_occurrences,
        abnormal_occurrence_types_select: newProps.abnormal_occurrence_types_select,
        flight_report_legs_select: newProps.flight_report_legs_select,
        flight_report: newProps.flight_report,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      flight_report_id: this.state.flight_report_id,
      flight_report_leg_id: this.state.flight_report_leg_id,
      abnormal_occurrence_type_id: this.state.abnormal_occurrence_type_id,
      observations: this.state.observations,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voo/ocorrencia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  delete (id) {
    if (window.confirm('Tem certeza que deseja excluir essa ocorrência?')) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/ocorrencia', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Cadastrar ocorrências anormais</h3>
  <hr/>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-3 form-group">
        <label>Trecho:</label>
        <Select
          className="form-field-name"
          name="flight_report_leg_id"
          value={this.state.flight_report_leg_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'flight_report_leg_id')}
          options={this.state.flight_report_legs_select}
          required
        />
      </div>
      <div className="col-md-3 form-group">
        <label>Tipo:</label>
        <Select
          className="form-field-name"
          name="abnormal_occurrence_type_id"
          value={this.state.abnormal_occurrence_type_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'abnormal_occurrence_type_id')}
          options={this.state.abnormal_occurrence_types_select}
          required
        />
      </div>
      <div className="col-md-3 form-group">
        <label>Observações:</label>
        <input type="text" name="observations" className="form-control" placeholder="" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} required />
      </div>
      <div className="col-md-3 form-group">
        <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Adicionar ocorrência</button>
      </div>
    </div>
  </form>
  <hr/>
  <h4 className="page-title">Ocorrências cadastradas</h4>
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>Trecho</th>
          <th>Tipo</th>
          <th>Observações</th>
          <th className="col-md-1 text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
      {Object.keys(self.state.flight_report_occurrences).map(function(k) {
        var srr = self.state.flight_report_occurrences[k];
        return (
          <tr>
            <td>
            {(srr.flight_report_leg === null ) ? '' :
              <span>{srr.flight_report_leg.leg_number}</span>
            }
            </td>
            <td>{srr.abnormal_occurrence_type.type}</td>
            <td>{srr.observations}</td>
            <td className="text-center">
              <button onClick={() => self.delete(srr.id)} className="btn btn-danger btn-sm"><i className="fa fa-trash"></i></button>
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>
</div>
    );
  }
}

export default FlightReportOcurrencesTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportOcurrencesTab.js